import { getRequestReviewCountApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react';
import { GoQuestion } from "react-icons/go";
import PremiumInfo from './PremiumInfo';




function ProfessionalsInvolved({detail, reqRevCountArr, attorney, leaveExtraTags = false}) {

  useEffect(() => {
    if(reqRevCountArr !== null && reqRevCountArr !== undefined && reqRevCountArr?.[detail?._id])
      {
        let sum = 0;
        let sumReview = 0;
         Object.values(reqRevCountArr?.[detail?._id]).map((i)=> 
          {
            sum =  parseInt(i)+parseInt(sum);
          });
          setRequests(sum);
          Object.keys(reqRevCountArr?.[detail?._id]).map((i)=> 
          {
            if((i !== "requested") && (i !== "denied") && (i !== "conflict")) {
              sumReview = parseInt(reqRevCountArr?.[detail?._id]?.[i]) + parseInt(sumReview)
            }
          });
          setReview(sumReview);

      }

 }, [reqRevCountArr])
  const [onHover, setOnHover] = useState(false);
  const [onHoverReview, setOnHoverReview] = useState(false);
  const [onHoverWhole, setOnHoverWhole] = useState(false);
  const [requests, setRequests] = useState(0);
  const [review, setReview] = useState(0);
  return (
    <div className='flex w-full flex-col'>
      {
        !leaveExtraTags &&
      
        <PremiumInfo detail={detail} attorney={attorney}/>
      }
        <div className='flex w-full mt-4 text-xs items-center relative'>
            <div 
             onMouseEnter={() => setOnHover(true)}
             onMouseLeave={() => setOnHover(false)}
            className='flex border-gray-400 mr-2 cursor-pointer bg-gray-100 font-bold border rounded-full p-1 px-2 w-max text-gray-600 '>
                
                <div>
                  Requests :&nbsp;</div>
                <div>
                  
                  {
                (requests ? requests : "None")
                  }</div>
            </div>
            {onHover && 
            <>
            <div className='absolute  bg-sky-200 w-max rounded font-medium border border-sky-200 -top-14 p-2'>
                <div>The total number of legal <br/> professionals who showed interest</div>
                <div className="border-[16px] border-b-0 border-r-transparent border-l-transparent border-t-sky-200 h-0 w-0 absolute -bottom-2"></div> 
              </div></>}
            <div 
            onMouseEnter={() => setOnHoverReview(true)}
            onMouseLeave={() => setOnHoverReview(false)}
            className='flex border border-gray-400 cursor-pointer font-bold bg-gray-100 rounded-full p-1 px-2 w-max  text-gray-600'>
                <div
                 
                >In Review :&nbsp;</div>
                <div>{(review ? review : "None")}</div>
                {onHoverReview && 
                  <>
                  
                  <div className='absolute bg-sky-200 text-black w-max rounded font-medium border border-sky-200 -top-14 p-2'>
                      <div>The total number of legal <br/> professionals who progressed to viewing </div>
                      <div className="border-[16px] border-b-0 border-r-transparent border-l-transparent border-t-sky-200 h-0 w-0 absolute -bottom-2"></div> 
                    </div>
                  </>}
            </div>
            {/* <div className='relative z-10'>
              <GoQuestion 
              onMouseEnter={() => setOnHoverWhole(true)}
              onMouseLeave={() => setOnHoverWhole(false)}
              className='ml-1 h-4 w-4 '/>
              {onHoverWhole && 
              <>
              
              <div className='absolute z-20 bg-sky-200 text-black w-max rounded font-medium border border-sky-200 bottom-8 p-2'>
              <div className="border-[14px] border-b-0 border-r-transparent border-l-transparent border-t-sky-200 h-0 w-0 absolute -bottom-3"></div> 

                  <div><b>Requests</b> - The total number of legal <br/> professionals who showed interest<br/>  </div>
                  <div><b>Review</b> - The total number of legal <br/> professionals who progressed to viewing </div>
                </div></>}
            </div> */}
           
        </div>

    </div>
  )
}

export default ProfessionalsInvolved